import { createEffect, createEvent, sample } from 'effector'

import { createHideFx } from '@/shared/ui/modal'

import { acceptTerms } from './lib'

export const showFx = createEffect<{ onAcceptButtonClick: () => void }, string>()
export const hideFx = createHideFx(showFx)

export const acceptTermsButtonClicked = createEvent()

const acceptTermsFx = createEffect(acceptTerms)

sample({
    clock: acceptTermsButtonClicked,
    target: [hideFx, acceptTermsFx],
})
